<!-- eslint-disable -->
<template>
    <div>
        <div class="text-black mb-4 leading-7 md:leading-6 text-lg md:text-xl" v-text="serviceInformationSnippet"></div>
        <div v-show="currentStep === 1">
            <ApplicationFormInput
                v-for="(field, index) in steps[1]"
                v-show="currentStep === 1"
                v-bind="field"
                ref="formInputs"
                :key="getInputKey(field.step, index)"
                v-model:valid="field.valid"
                v-model="field.value"
                :index="index"
                :is-france="isFrance"
                :active="activeQuestion === index"
                :clickable="index <= lastAnsweredQuestion || !field.required"
                :total="steps[1].length"
                @datesdata="pushDate"
                @active-changed="activeChanged($event)"
                @confirmed="handleInputConfirmedEvent(field)"
            ></ApplicationFormInput>

            <div class="py-20 text-gray opacity-100 transition duration-200">
                <div class="grid grid-cols-12">
                    <div class="col-span-12">
                        <div class="hidden">
                            <div class="relative mb-4">
                                <button
                                    class="rounded py-4 px-10 bg-blue border-2 border-blue text-white text-lg block w-full mb-4 text-left cursor-poiner transition duration-200 hover:border hover:border-blue hover:bg-blue hover:text-white relative after:content-['\F0A8'] after:font-extrabold after:text-xl after:absolute after:right-5 after:top-3 focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                                    type="submit"
                                    :disabled="isSubmitting"
                                    @click.once.prevent="submitForm('company')"
                                    v-text="formSendSnippet"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" name="adult_year" :value="selectedAdultYear" />
        <input type="hidden" name="submit_type" :value="submitType" />
        <input type="hidden" name="submit_type_description" :value="submitTypeDescription" />
        <input type="hidden" name="location" :value="location" />
    </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import ApplicationFormInput from "./ApplicationFormInput";
import formFR from "../forms/fr";

const FORM_DATA = formFR;

const props = defineProps({
    initialValues: {
        type: Object,
        default: () => {},
    },
    isFrance: {
        type: Boolean,
        default: false,
    },
    initialStep: {
        type: String,
        default: "",
    },
    employeePicture: {
        type: String,
        default: "",
    },
    employeeName: {
        type: String,
        default: "",
    },
    chatText: {
        type: String,
        default: "",
    },
    chatTextEighteen: {
        type: String,
        default: "",
    },
    buttonLeft: {
        type: String,
        default: "",
    },
    buttonRight: {
        type: String,
        default: "",
    },
    serviceInformationSnippet: {
        type: String,
        required: true,
    },
    formSendSnippet: {
        type: String,
        required: true,
    },
});

const currentStep = ref(1);
const selectDate = ref([]);
const selectedAdultYear = ref(null);
const submitType = ref(null);
const location = ref(window.location.href);
const activeQuestion = ref(0);
const isSubmitting = ref(false);
const isSubmittingSecondStep = ref(false);
const form = ref(FORM_DATA);

const formInputs = ref(null);

const steps = computed(() => {
    const steps = {};

    form.value.forEach((question) => {
        const stepName = question.step;
        if (!steps[stepName]) {
            steps[stepName] = [];
        }

        steps[stepName].push(question);
    });

    return steps;
});

const currentStepIsValid = computed(() => steps[currentStep.value].findIndex(({ valid }) => valid === false) === -1);

const lastAnsweredQuestion = computed(() => {
    const answeredQuestions = steps[currentStep.value].filter(({ value }) => value !== "");

    if (answeredQuestions.length === 0) return 0;

    return answeredQuestions.length;
});

const setInitialValuesFromStorage = () => {
    form.value.map((question) => {
        if (localStorage["application_form.required_date_until_dates"] && question.name === "required_date_until") {
            question.value = localStorage["application_form.required_date_until"];
            question.defaultDate = localStorage["application_form.required_date_until"];
            question.options = JSON.parse(localStorage["application_form.required_date_until_dates"]);
            return question;
        }

        if (localStorage[`application_form.${question.name}`] && question.type !== "file") {
            question.value = localStorage[`application_form.${question.name}`];
            return question;
        }

        return question;
    });
};

const setInitialValues = () => {
    Object.keys(props.initialValues).forEach((key) => {
        if (!props.initialValues[key]) {
            return key;
        }

        const question = form.value.find(({ name }) => name === key);
        question.value = props.initialValues[key];

        return key;
    });
};

const submitTypeDescription = () => "Franse Camping formulier";

const goToStep = (step) => {
    currentStep.value = step;
    activeQuestion.value = 0;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};

onMounted(() => {
    setInitialValuesFromStorage();
    setInitialValues();

    const initialStep = parseInt(props.initialStep, 10);
    if (initialStep > 1) {
        goToStep(initialStep);
    }

    nextTick(() => {
        activeQuestion.value = steps[currentStep.value].findIndex(({ value }) => value === "");

        if (activeQuestion.value === -1 || form.value[activeQuestion.value].step !== currentStep.value) {
            return;
        }

        formInputs[activeQuestion.value].focus();
    });
});

const activeChanged = (newValue) => {
    activeQuestion.value = newValue;
};

const pushDate = (dates) => {
    form.value[6].options = [];
    dates.forEach((element) => form.value[6].options.push(element));
    form.value[6].defaultDate = dates[0];
};

const submitForm = (type) => {
    if (type === "step1" || type === "sendInfo") {
        isSubmitting.value = true;
    }

    submitType.value = type;

    nextTick(() => {
        document.getElementById("application-form-company").submit();
    });
};

const handleInputConfirmedEvent = (field) => {
    const nextIndex = form.value.indexOf(field) + 1;
    const component = formInputs;
    const nextField = form.value[nextIndex];

    if (!nextField) {
        return;
    }

    if (nextField.step !== field.step) {
        return;
    }

    if (!component[nextIndex]) {
        return;
    }

    component[nextIndex].focus();
};

const getInputKey = (step, index) => `step${step}_${index}`;
</script>
